/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {registerProps as ɵb} from './carousel-template/carousel-template.props';
export {registerProps as ɵa} from './carousel.props';